/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Col,
  Button,
  Row,
} from 'antd';
import Select from 'components/Select';

export const tabConfigURsPermission = {
  model: 'configuraciondeur',
  catalogs: [],
};

const ConfiguracionesUR = ({
  disabled,
  form,
  conceptoUR,
  periodoFiscalSelected,
}) => {
  const rules = { required: [{ required: true }] };

  return (
    <Form
      layout="vertical"
      form={form}
      scrollToFirstError
      initialValues={{ periodo_fiscal: periodoFiscalSelected?.id }}
    >
      <Row gutter={10}>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="periodo_fiscal"
            rules={rules.required}
            label="Ejercicio"
            hasFeedback={!disabled}
          >
            <Select
              dataSource={[periodoFiscalSelected]}
              render={(item) => item.periodo}
              disabled
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="concepto_de_ur"
            label="Concepto de UR"
            hasFeedback={!disabled}
          >
            <Select dataSource={conceptoUR} disabled={disabled} />
          </Form.Item>
        </Col>
        <Form.Item hidden>
          <Button htmlType="submit" />
        </Form.Item>
      </Row>
    </Form>
  );
};

ConfiguracionesUR.propTypes = {
  disabled: PropTypes.bool,
  form: PropTypes.instanceOf(Form).isRequired,
  conceptoUR: PropTypes.array.isRequired,
  periodoFiscalSelected: PropTypes.any.isRequired,
};

ConfiguracionesUR.defaultProps = {
  disabled: false,
};

export default ConfiguracionesUR;
